module.exports = __webpack_public_path__ + "static/media/lt.3cf0cf87.svg";